import type { AwsUploadFileDto } from '@/castapi';
import type { AxiosPromise } from 'axios';

interface AwsApi {
  awsControllerUploadFile(body: AwsUploadFileDto): AxiosPromise<string>;
}

export const uploadImage = async (
  avatarImage: string,
  pathWithoutExtension: string,
  awsApi: AwsApi,
  addTime = true,
): Promise<string> => {
  let array = /^data:image\/(\w+);base64,/.exec(avatarImage);
  let extension = array?.length ? `.${array[1]}` : '';
  if (!extension) {
    array = /^data:application\/(pdf);base64,/.exec(avatarImage);
    extension = array?.length ? `.${array[1]}` : '';
  }
  const body = { file: avatarImage as unknown as object, path: `${pathWithoutExtension}${extension}` };
  const { data: url } = await awsApi.awsControllerUploadFile(body);
  const symbol = url.includes('?') ? '&' : '?';
  return addTime ? `${url}${symbol}${new Date().getTime()}` : url; // Clarification: it's trick to avoid caching image by url
};
